import { UserData } from "core/queries/GetTeam";
import { UserFilterInput } from "typings/globalGQLTypes";

export enum ActionType {
  AddUndo = "ADD_UNDO",
  RemoveUndo = "REMOVE_UNDO",
  SetFilters = "SET_FILTERS",
}

export enum UndoAction {
  ADD_MEMBER = "ADD_MEMBER",
  REMOVE_MEMBER = "REMOVE_MEMBER",
}

export interface AddUndoAction {
  type: ActionType.AddUndo;
  payload: {
    action: UndoAction;
    user: UserData;
  };
}
export const addUndo = (action: UndoAction, user: UserData): AddUndoAction => ({
  type: ActionType.AddUndo,
  payload: {
    action,
    user,
  },
});

export interface RemoveUndoAction {
  type: ActionType.RemoveUndo;
}
export const removeUndo = (): RemoveUndoAction => ({
  type: ActionType.RemoveUndo,
});

export interface SetFiltersAction {
  type: ActionType.SetFilters;
  payload: UserFilterInput;
}
export const setFilters = (filter: UserFilterInput): SetFiltersAction => ({
  type: ActionType.SetFilters,
  payload: filter,
});
